import PropTypes from 'prop-types';
import React from 'react';

import useTranslation from '../../hooks/use_translation';
import Link from '../framework/link';

const AddProduct = ({ count, status, title }) => {
	const { t } = useTranslation('component_add_product');

	return (
		<>
			{t('t1', { title })} {status == 'replace' && <>{t('t2', { count })}</>}{' '}
			<Link className="x-small text-white uppercase" to={`/varukorg/`}>
				{t('t3')}
			</Link>
		</>
	);
};

AddProduct.propTypes = {
	count: PropTypes.number,
	status: PropTypes.string,
	title: PropTypes.string,
	toast_id: PropTypes.string,
	variant: PropTypes.string,
};

export default AddProduct;
